import {
  ICapability,
  ICapabilityDomainEnum,
  ICapabilityLevelEnum,
} from '@r-client/data/graphql-types';

export type TAccess = {
  domain: ICapabilityDomainEnum;
  level?: ICapabilityLevelEnum;
};

export const hasUserAccessLevel = (
  userAccessLevel: ICapabilityLevelEnum,
  domainAccessLevel: ICapabilityLevelEnum
): boolean => {
  if (
    userAccessLevel === ICapabilityLevelEnum.Full &&
    [
      ICapabilityLevelEnum.Full,
      ICapabilityLevelEnum.Manager,
      ICapabilityLevelEnum.Support,
    ].includes(domainAccessLevel)
  )
    return true;
  if (
    userAccessLevel === ICapabilityLevelEnum.Manager &&
    [ICapabilityLevelEnum.Manager, ICapabilityLevelEnum.Support].includes(
      domainAccessLevel
    )
  )
    return true;
  if (
    userAccessLevel === ICapabilityLevelEnum.Support &&
    ICapabilityLevelEnum.Support === domainAccessLevel
  )
    return true;

  return false;
};

export const hasUserAccess = (
  access: TAccess,
  userCapabilities: ICapability[]
): boolean => {
  const accessedDomains = userCapabilities.map((c) => c.domain);
  if (accessedDomains.includes(access?.domain) && !access.level) return true;
  const domain = userCapabilities.find((c) => c.domain === access.domain);
  if (
    domain?.level &&
    access.level &&
    hasUserAccessLevel(domain?.level, access.level)
  )
    return true;
  return false;
};

export const hasCapability = (
  capabilities: ICapability[],
  domain: ICapabilityDomainEnum
): ICapability | undefined => capabilities.find((c) => c.domain === domain);
